
import { useParams } from 'react-router-dom';
import ProductDetailHero from './components/ProductDetailHero';
import ProductFeatures from './components/ProductFeatures';
import ProductSpecifications from './components/ProductSpecifications';
import ComplianceSection from './components/ComplianceSection';
import RelatedProducts from './components/RelatedProducts';
import ProductCTA from './components/ProductCTA';

export default function ProductDetailPage() {
  const { id } = useParams();

  // Sample product data - in a real app, this would come from an API
  const product = {
    id: 1,
    title: 'Fire Alarm Control Panel – Addressable Type',
    category: 'Fire Alarm Systems',
    brand: 'FlameGuardQA',
    model: 'FG-ACP-01',
    certification: 'QCDD Approved',
    status: 'Available',
    image: 'https://readdy.ai/api/search-image?query=Professional%20intelligent%20fire%20alarm%20control%20panel%20with%20digital%20LCD%20display%20and%20red%20indicator%20lights%2C%20advanced%20addressable%20fire%20detection%20system%20with%20network%20connectivity%20and%20QCDD%20approval%20certification%20in%20Qatar%20commercial%20building&width=600&height=600&seq=alarm-control-panel&orientation=squarish',
    description: 'The FlameGuardQA Addressable Fire Alarm Control Panel provides advanced fire detection and monitoring for all types of buildings. Designed with intelligent control features and real-time alarm notifications, it ensures reliable operation and early warning in case of emergencies.'
  };

  const features = [
    'Intelligent addressable detection with zone monitoring',
    'LCD display with system status indicators',
    'Compatible with multiple detector types',
    'Event history storage and remote monitoring',
    'Easy installation and maintenance',
    'Fully compliant with QCDD standards',
    'Network connectivity for building management systems',
    'Battery backup with automatic charging'
  ];

  const specifications = [
    { label: 'Model', value: 'FG-ACP-01' },
    { label: 'Type', value: 'Addressable Fire Alarm Panel' },
    { label: 'Power Supply', value: '230V AC, 50Hz' },
    { label: 'Zones', value: 'Up to 8' },
    { label: 'Display', value: '4-Line LCD with Backlight' },
    { label: 'Operating Temperature', value: '-10°C to +55°C' },
    { label: 'Humidity Range', value: '10% to 95% RH' },
    { label: 'Dimensions', value: '400 x 300 x 120 mm' },
    { label: 'Weight', value: '5.2 kg' },
    { label: 'Certifications', value: 'QCDD, UL Listed, EN54' },
    { label: 'Warranty', value: '2 Years' },
    { label: 'Installation', value: 'Wall Mount' }
  ];

  const relatedProducts = [
    {
      id: 2,
      title: 'Smoke & Heat Detectors',
      image: 'https://readdy.ai/api/search-image?query=Professional%20smoke%20and%20heat%20detectors%20mounted%20on%20white%20ceiling%2C%20QCDD%20approved%20fire%20detection%20sensors%20with%20red%20LED%20indicators%20and%20clean%20technical%20installation%20in%20Qatar%20commercial%20building&width=300&height=200&seq=smoke-detectors&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'EN54 Certified'
    },
    {
      id: 3,
      title: 'Manual Call Points',
      image: 'https://readdy.ai/api/search-image?query=Red%20break%20glass%20manual%20fire%20alarm%20call%20point%20mounted%20on%20white%20wall%2C%20professional%20fire%20safety%20activation%20device%20with%20protective%20cover%20and%20QCDD%20approval%20marking%20in%20Qatar%20building&width=300&height=200&seq=manual-call-points&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'IP65 Rated'
    },
    {
      id: 4,
      title: 'Fire Alarm Sounders',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20alarm%20sounder%20and%20strobe%20light%20with%20red%20housing%2C%20QCDD%20approved%20audible%20and%20visual%20alarm%20notification%20device%20for%20Qatar%20commercial%20buildings&width=300&height=200&seq=alarm-sounders&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'QCDD Approved'
    },
    {
      id: 5,
      title: 'Fire Alarm Cables',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20alarm%20cables%20and%20wiring%20with%20red%20insulation%2C%20QCDD%20approved%20fire%20resistant%20electrical%20cables%20for%20fire%20detection%20systems%20in%20Qatar%20buildings&width=300&height=200&seq=alarm-cables&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'Fire Resistant'
    }
  ];

  return (
    <div className="min-h-screen">
      <ProductDetailHero product={product} />
      <ProductFeatures features={features} />
      <ProductSpecifications specifications={specifications} />
      <ComplianceSection />
      <RelatedProducts products={relatedProducts} />
      <ProductCTA />
      
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-8 right-8 z-50">
        <button className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center group">
          <i className="ri-whatsapp-line text-2xl group-hover:scale-110 transition-transform"></i>
        </button>
      </div>
    </div>
  );
}
